import type { DataQualityFinding } from '@ace-tracker/shared';

const SEVERITY_LABEL: Record<DataQualityFinding['severity'], string> = {
  blocker: 'Blocker',
  high: 'High',
  info: 'Info',
};

const SEVERITY_CLASS: Record<DataQualityFinding['severity'], string> = {
  blocker: 'bg-error text-text-inverse',
  high: 'bg-warning text-text-default',
  info: 'bg-info text-text-inverse',
};

export function DataQualityBanner({ findings }: { findings: DataQualityFinding[] }) {
  if (findings.length === 0) return null;

  return (
    <details className="rounded-card border border-error bg-crit-bg">
      <summary className="cursor-pointer select-none list-none px-4 py-3 text-sm font-bold text-crit-ink [&::-webkit-details-marker]:hidden">
        <span className="inline-flex items-center gap-2">
          <span
            className="inline-block h-0 w-0 border-y-4 border-y-transparent border-l-[6px] border-l-crit-ink transition-transform [details[open]_&]:rotate-90"
            aria-hidden="true"
          />
          Data quality notices ({findings.length})
        </span>
      </summary>
      <ul className="grid gap-2 px-4 pb-4">
        {findings.map((f, i) => (
          <li key={i} className="grid grid-cols-[auto_1fr] items-start gap-2.5 text-sm text-text-default">
            <span className={`mt-0.5 whitespace-nowrap rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide ${SEVERITY_CLASS[f.severity]}`}>
              {SEVERITY_LABEL[f.severity]}
            </span>
            <span>{f.message}</span>
          </li>
        ))}
      </ul>
    </details>
  );
}
